import { ExplicitSelectionButton } from '@yes.technology/react-toolkit'
import { useEffect } from 'react'
import { ActivityModel } from 'types/shared'
import useFetchSuggestions from '../../../hooks/useFetchSuggestions'
import { ActivityInputProps } from '../Activity.types'

export type ActivityExplicitUniselectionProps = {
  id: string
  parentPath: string[]
  label: string
  value: ActivityModel['value']
  filteraction?: string
  onChange: ActivityInputProps['handleChange']
  disabled?: boolean
} & Pick<
  React.ComponentProps<typeof ExplicitSelectionButton>,
  'id' | 'label' | 'options' | 'optionLabelsPosition' | 'direction' | 'required'
>

const ActivityExplicitUniselection = ({
  id,
  parentPath,
  label,
  value,
  options = [],
  onChange,
  direction,
  optionLabelsPosition,
  filteraction,
  required,
  disabled
}: ActivityExplicitUniselectionProps) => {
  const { suggestions, fetchSuggestions } = useFetchSuggestions({
    parentPath,
    filteraction,
    showLoading: true
  })

  useEffect(() => {
    if (!filteraction) {
      return
    }

    fetchSuggestions('.*')
  }, [fetchSuggestions, filteraction])

  const finalOptions = options.length ? options : suggestions

  const checkedOption = finalOptions.find(
    (option) => typeof value === 'object' && option.uuid === value?.id
  )

  const handleChange = ({ des, uuid }: { des: string; uuid: string }) => {
    const checkedLabel = checkedOption?.des === des ? '' : des

    checkedLabel && onChange({ id: uuid, des: checkedLabel })
  }

  return (
    <ExplicitSelectionButton
      heightClass='regular'
      label={label}
      selectionType='uniselection'
      options={finalOptions}
      direction={direction}
      optionLabelsPosition={optionLabelsPosition}
      checkedOption={checkedOption?.uuid || ''}
      id={id}
      required={required}
      disabled={disabled}
      onChange={handleChange}
    />
  )
}

export default ActivityExplicitUniselection
